import IRequest from "../../IRequest";

export interface ITiposDocPagar {
    reqTiposDocumentos: IRequest<TTipoDocPagar>,
    dataTiposDocumentos: TTipoDocPagar[]
  }

export type TTipoDocPagar = {
  id: string;
  nome: string;
  sugestao_numero: number;
}

export const defValueTipoDocPagar = {
  id: '',
  nome: '',
  sugestao_numero: 0,
}